import * as api from '../../../api';

export interface Option {
  label: string;
  value: string;
}

const stateOptions: Option[] = Object.entries(
  api.PrevisitAddress.UsStates.US_STATES_MAPPING,
).map(([abrv, state]) => ({
  label: state,
  value: abrv,
}));

const countryOptions: Option[] = [
  {
    label: 'United States',
    value: 'US',
  },
];

interface BaseFormRow {
  label: string;
  field: string;
}

interface SelectRow extends BaseFormRow {
  type: 'select';
  options: Option[];
}
interface TextRow extends BaseFormRow {
  type: 'text' | 'number';
  placeholder: string;
  validationRegex?: RegExp;
}

type FormRowOption = SelectRow | TextRow;

export const formRows: FormRowOption[] = [
  { label: 'Name', field: 'name', type: 'text', placeholder: 'Jenny Rosen' },
  {
    label: 'Email',
    field: 'email',
    type: 'text',
    placeholder: 'jenny@example.com',
  },
  {
    label: 'Address',
    field: 'address.line1',
    type: 'text',
    placeholder: '185 Berry Suite',
  },
  {
    label: 'City',
    field: 'address.city',
    type: 'text',
    placeholder: 'San Francisco',
  },
  {
    label: 'State',
    field: 'address.state',
    type: 'select',
    options: stateOptions,
  },
  {
    label: 'Zip',
    field: 'address.postal_code',
    type: 'text',
    placeholder: '94107',
    validationRegex: /^[0-9]{0,4}$|^[0-9]{5}(?:-[0-9]{0,4})?$/, // allow building of zip code chars only
  },
  {
    label: 'Country',
    field: 'address.country',
    type: 'select',
    options: countryOptions,
  },
];
